import type {Editor} from 'grapesjs';
import {buildDefaultFormsWrapperLayout} from '@FormMakerReact/components/postermywall-forms-wrapper/postermywall-forms-wrapper';

export function seedDefaultLayout(editor: Editor): void {
  if (editor.getComponents().length > 0) {
    return;
  }

  editor.UndoManager.skip((): void => {
    editor.addComponents(buildDefaultFormsWrapperLayout());
  });
}
